import { render } from "./NIS2Dashboard.vue?vue&type=template&id=7bf3237a"
import script from "./NIS2Dashboard.vue?vue&type=script&lang=js"
export * from "./NIS2Dashboard.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__